import { FEET, HAWAIIAN } from '@surfline/web-common';

const getUnitType = (unitType: string | null = null) => {
  if (unitType == null) return null;
  if (unitType === HAWAIIAN) return FEET;
  return unitType; // no transformation needed
};

export default getUnitType;
